import { render, staticRenderFns } from "./usuario-form.vue?vue&type=template&id=2d83024e&scoped=true&"
import script from "./usuario-form.vue?vue&type=script&lang=js&"
export * from "./usuario-form.vue?vue&type=script&lang=js&"
import style0 from "./usuario-form.vue?vue&type=style&index=0&id=2d83024e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83024e",
  null
  
)

export default component.exports